// Module
var code = "<div class=\"preview-field\"> <span class=\"preview-field-title\">{{ vm.title }}</span> <span class=\"preview-field-value\">{{ vm.value }}</span> </div> ";
// Exports
module.exports = code;